// Formatting for the session-based Readings Review (SCRUM-844).

// "1951-06-02" -> "06/02/1951". The API sends DOB as a plain date with no
// time zone, so it's split as text - never passed through Date, which would
// shift it a day for reviewers west of UTC.
export const formatDob = (dob) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(dob || "");
  return match ? `${match[2]}/${match[3]}/${match[1]}` : dob || "—";
};

// ISO UTC timestamp -> local "3:05 PM".
export const formatTime = (iso) => {
  const d = iso ? new Date(iso) : null;
  if (!d || Number.isNaN(d.getTime())) return "";
  return d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" });
};

// ISO UTC timestamp -> local "1/16/2026 3:05pm" (Figma's reading date format).
export const formatReadingDate = (iso) => {
  const d = iso ? new Date(iso) : null;
  if (!d || Number.isNaN(d.getTime())) return "—";
  const time = d
    .toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" })
    .replace(" ", "")
    .toLowerCase();
  return `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()} ${time}`;
};

export const fullName = (patient) =>
  [patient?.first_name, patient?.last_name].filter(Boolean).join(" ") || patient?.id || "—";
